import { Helmet } from 'react-helmet-async';
import { useOrganization } from '../contexts/OrganizationContext';

export const MetaTitle = () => {
  const { organization } = useOrganization();

  // Formato: "Nankin - Nome da Empresa" ou apenas "Nankin" se não houver organização
  const title = organization?.name ? `Nankin - ${organization.name}` : 'Nankin';

  return (
    <Helmet>
      <title>{title}</title>
      <link
        rel="icon"
        type="image/png"
        href="/favicon.png"
      />
    </Helmet>
  );
}; 